module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "title",
      "required": "",
      "label": "Título"
    },
    model: {
      value: (_vm.menu.title),
      callback: function($$v) {
        _vm.$set(_vm.menu, "title", $$v)
      },
      expression: "menu.title"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "to",
      "label": "Link"
    },
    model: {
      value: (_vm.menu.to),
      callback: function($$v) {
        _vm.$set(_vm.menu, "to", $$v)
      },
      expression: "menu.to"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "icon",
      "label": "Ícone"
    },
    model: {
      value: (_vm.menu.icon),
      callback: function($$v) {
        _vm.$set(_vm.menu, "icon", $$v)
      },
      expression: "menu.icon"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "ordem",
      "required": "",
      "label": "Ordem"
    },
    model: {
      value: (_vm.menu.ordem),
      callback: function($$v) {
        _vm.$set(_vm.menu, "ordem", $$v)
      },
      expression: "menu.ordem"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "chips": "",
      "autocomplete": "",
      "label": "Permissões",
      "items": _vm.itemsPermissoes,
      "item-text": "authority",
      "item-value": "id",
      "multiple": "",
      "max-height": "400",
      "hint": "Selecione as permissões",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.menu.permissoes),
      callback: function($$v) {
        _vm.$set(_vm.menu, "permissoes", $$v)
      },
      expression: "menu.permissoes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "chips": "",
      "autocomplete": "",
      "label": "Menu Pai",
      "items": _vm.itemsMenu,
      "item-text": "title",
      "item-value": "id",
      "max-height": "400",
      "hint": "Selecione o menu pai",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.menu.menuPai),
      callback: function($$v) {
        _vm.$set(_vm.menu, "menuPai", $$v)
      },
      expression: "menu.menuPai"
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeoutAlerta,
      "color": _vm.tipoAlerta
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textAlerta) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b00c717"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuForm.vue
// module id = 368
// module chunks = 1